import { Component } from '@angular/core';

@Component({
  selector: 'app-order-timespan',
  imports: [],
  templateUrl: './order-timespan.component.html',
  styleUrl: './order-timespan.component.scss'
})
export class OrderTimespanComponent {

}
